import Model from './model'

export default class User extends Model {
    /**
     *
     * @returns {string}
     */
    resource() {
        return 'web-api/user'
    }
}
